// extracted by mini-css-extract-plugin
module.exports = {"checkboxesContainer":"CreateEditClinics_checkboxesContainer__1J28c","emails":"CreateEditClinics_emails__1F25E","emailTagLabel":"CreateEditClinics_emailTagLabel__3EKRa"};